import { http, HttpResponse } from 'msw';
const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/signate_notifications`;

type SignateNotificationsRecordType = Required<{
  id: number;
  title: string;
  body: string;
  display_kind: 'none' | 'important';
  started_at: string;
  finished_at: string;
  external_link_url: string | null;
}>;

const signateNotificationsRecords: SignateNotificationsRecordType[] = [
  {
    id: 1,
    title: 'お知らせ1',
    body: 'お知らせ1を表示します。',
    display_kind: 'none',
    started_at: '2024-01-01T12:00:00+09:00',
    finished_at: '2024-12-02T12:00:00+09:00',
    external_link_url: 'https://signate.jp',
  },
  {
    id: 2,
    title: 'お知らせ2',
    body: 'お知らせ2を表示します。',
    display_kind: 'none',
    started_at: '2024-01-03T12:00:00+09:00',
    finished_at: '2024-12-04T12:00:00+09:00',
    external_link_url: null,
  },
  {
    id: 3,
    title: 'お知らせ3',
    body: 'お知らせ3を表示します。',
    display_kind: 'important',
    started_at: '2024-01-05T12:00:00+09:00',
    finished_at: '2024-12-06T12:00:00+09:00',
    external_link_url: null,
  },
];

export const signateNotificationsHandlers = [
  // SIGNATE からのお知らせ一覧取得(サインイン前)
  http.get(`${baseUrl}/un_signed_in`, async ({ request }) => {
    const filteredRecords: SignateNotificationsRecordType[] =
      signateNotificationsRecords;
    const searchRequest = Object.fromEntries(
      new URL(request.url).searchParams.entries()
    ) as Required<{
      target_page: 'sign_in';
      order_by: string;
      desc_order: string;
      page: string;
      per: string;
    }>;

    console.group(baseUrl);
    console.table(searchRequest);

    filteredRecords.sort((a, b) => {
      return searchRequest.order_by && searchRequest.desc_order === 'true'
        ? b.id - a.id
        : a.id - b.id;
    });

    console.info(filteredRecords);

    const per = searchRequest.per ? Number(searchRequest.per) : 20;
    const lastPage = Math.ceil(filteredRecords.length / per);
    const paginatedSearchedRecords = new Array(lastPage)
      .fill(undefined)
      .map((_, i) => filteredRecords.slice(i * per, (i + 1) * per));
    const currentPage =
      (searchRequest.page ? Number(searchRequest.page) : 1) > lastPage
        ? lastPage
        : searchRequest.page
        ? Number(searchRequest.page)
        : 1;

    const response = {
      signateNotifications: paginatedSearchedRecords[currentPage - 1],
      total_count: filteredRecords.length,
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
];
